import type { ReactNode } from "react";
import { Separator } from "@/components/ui/separator";
import { formatCm } from "@/lib/text-metrics";
import { calculatePriceChf, formatChf } from "@/lib/pricing";
import type { FontOption } from "@/lib/fonts";
import type { ColorOption } from "@/lib/colors";

interface SummaryCardProps {
  text: string;
  font: FontOption;
  color: ColorOption;
  widthCm: number;
  heightCm: number;
  depthMm: number;
}

function Row({ label, value }: { label: string; value: ReactNode }) {
  return (
    <div className="flex items-center justify-between py-1.5 text-sm">
      <span className="text-muted-foreground">{label}</span>
      <span className="font-medium">{value}</span>
    </div>
  );
}

export function SummaryCard({
  text,
  font,
  color,
  widthCm,
  heightCm,
  depthMm,
}: SummaryCardProps) {
  const chars = text.length;
  const priceChf = calculatePriceChf(widthCm, heightCm);
  return (
    <div className="rounded-xl border bg-card p-4">
      <h3 className="mb-1 text-sm font-semibold">Zusammenfassung</h3>
      <Separator className="mb-1" />
      <Row label="Text" value={text.length ? text : "–"} />
      <Row label="Schriftart" value={font.label} />
      <Row
        label="Farbe"
        value={
          <span className="inline-flex items-center gap-1.5">
            <span
              className="inline-block size-3 rounded-full border"
              style={{ backgroundColor: color.hex }}
            />
            {color.label}
          </span>
        }
      />
      <Row label="Breite" value={formatCm(widthCm)} />
      <Row label="Höhe" value={formatCm(heightCm)} />
      <Row label="Tiefe" value={`${depthMm} mm`} />
      <Row label="Zeichen" value={chars} />
      <Separator className="my-1" />
      <Row label="Preis" value={formatChf(priceChf)} />
    </div>
  );
}
